import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/* eslint-disable max-lines */
import * as React from 'react';
import { createIcon } from '../../../internal';

// eslint-disable-next-line react/display-name
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var IconComponent = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/_jsx("svg", _objectSpread(_objectSpread({}, props), {}, {
    ref: ref,
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /*#__PURE__*/_jsxs("g", {
      fill: "currentColor",
      children: [/*#__PURE__*/_jsx("path", {
        d: "M6.536 8.535c.78-.78.939-1.889.353-2.474-.586-.586-1.694-.428-2.475.353-.78.781-.94 1.89-.353 2.475.585.586 1.693.428 2.475-.354ZM9.06 6.06c-.585.586-.427 1.694.354 2.475.781.782 1.89.94 2.475.354.586-.586.428-1.694-.353-2.475-.782-.78-1.89-.94-2.475-.353Zm-1.438 6.504a.5.5 0 0 0 .756 0l1.504-1.737A.5.5 0 0 0 9.504 10H6.496a.5.5 0 0 0-.378.827l1.504 1.737Z"
      }), /*#__PURE__*/_jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M14.807 5.996C15.528 5.484 16 4.681 16 3.765 16 2.205 14.657.94 13 .94a3.06 3.06 0 0 0-2.029.76 6.184 6.184 0 0 0-5.942 0A3.062 3.062 0 0 0 3 .94c-1.657 0-3 1.264-3 2.824 0 .916.472 1.72 1.193 2.231C.015 8.345-.64 11.31.935 13.455 2.173 15.145 4.55 16 8 16s5.827-.856 7.065-2.543c1.575-2.146.92-5.113-.258-7.461Zm-1.387 6.39c-.843 1.149-2.666 1.732-5.42 1.732s-4.577-.583-5.42-1.731c-1.05-1.433-.417-3.61.055-4.78C3.085 6.484 4.808 2.824 8 2.824s4.914 3.66 5.365 4.783c.472 1.17 1.106 3.346.055 4.779Z"
      })]
    })
  }));
});

/**
 * Компонент иконки
 *
 * Некоторые иконки красятся в любые цвета из палитры, некоторые имеют зафиксированные цвета.
 */
export var IconInfrastructureZoo16 = createIcon(IconComponent);